// extracted by mini-css-extract-plugin
module.exports = {"root":"LandownerBanner_root__10JC3","cta":"LandownerBanner_cta__BZpdO","close":"LandownerBanner_close__3uU1l"};